import { Component } from './component';

export interface OptionButtonProps {
  name: string;
  value: string;
  disabled?: boolean;
}

export class OptionButton extends Component {
  public el: HTMLInputElement;

  constructor(props: OptionButtonProps) {
    super();

    this.el = document.createElement('input');
    this.el.setAttribute('type', 'radio');
    this.el.setAttribute('name', props.name);
    this.el.setAttribute('value', props.value);

    if (props.disabled) {
      this.el.setAttribute('disabled', 'disabled');
    }
  }

  setValue(checked: boolean) {
    this.el.checked = checked;
  }

  getValue(): boolean {
    return this.el.checked;
  }
}
